import React from 'react'
import { observer } from 'mobx-react'

import { Checkbox } from '../index'

export default observer(({ field, col, ...prop }) => (
  <Checkbox {...field.bind()} {...prop} />
))
